import { Col, Input, Label, Row, UncontrolledTooltip } from "reactstrap";
import React, { useCallback } from "react";
import ColorPicker from "../../../../components/ColorPicker/ColorPicker";

const SingleColorPicker = React.memo(
  ({ className, label, defaultColor, setStateFunc, tip }) => {
    return (
      <ColorPicker
        classOfContainer={className}
        labelText={label}
        defaultColor={defaultColor}
        setStateFunc={setStateFunc}
        tip={tip}
        idDiv={className}
      />
    );
  }
);

export const PortalConfigForm = React.memo(
  ({
    imageLoginScreen,
    imageLoginScreenPreview,
    setImageLoginScreen,
    setImageLoginScreenPreview,
    iconNavigationBar,
    iconNavigationBarPreview,
    setIconNavigationBar,
    setIconNavigationBarPreview,
    titleNavigationBar,
    setTitleNavigationBar,
    primaryColor,
    setPrimaryColor,
    secondaryColor,
    setSecondaryColor,
    configErrors,
    onImageChange,
  }) => {
    const handleSetPrimaryColor = useCallback(
      (val) => setPrimaryColor(val),
      [setPrimaryColor]
    );
    const handleSetSecondaryColor = useCallback(
      (val) => setSecondaryColor(val),
      [setSecondaryColor]
    );

    return (
      <>
        <h5>Configuração do Portal</h5>

        <Row>
          <Col md={8}>
            <Label>Imagem da Tela de Login*</Label>
            <Input
              type="file"
              onChange={(e) =>
                onImageChange(
                  e,
                  setImageLoginScreenPreview,
                  setImageLoginScreen
                )
              }
            />
            {configErrors.imageLoginScreen && (
              <small className="text-danger">
                {configErrors.imageLoginScreen}
              </small>
            )}
          </Col>

          {(imageLoginScreenPreview || imageLoginScreen) && (
            <Col md={4}>
              <img
                src={imageLoginScreenPreview || imageLoginScreen}
                alt="login"
                style={{ width: 80, borderRadius: 8, cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    imageLoginScreenPreview || imageLoginScreen,
                    "_blank"
                  )
                }
              />
            </Col>
          )}
        </Row>

        <Row className="mt-3">
          <Col md={8}>
            <Label style={{ display: "flex" }}>
              Ícone da Barra de Navegação*{" "}
              <div
                id="iconNavigationBarTip"
                style={{
                  height: "16px",
                  paddingLeft: "7px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div className="show-tips" style={{ cursor: "pointer" }}>
                  <span style={{ margin: 0 }}>?</span>
                </div>
                <UncontrolledTooltip
                  style={{ backgroundColor: "#6f42c1" }}
                  placement="right"
                  target="iconNavigationBarTip"
                >
                  O ícone deve ter 48x48px
                </UncontrolledTooltip>
              </div>{" "}
            </Label>

            <div style={{ display: "flex", alignItems: "center" }}>
              <Input
                type="file"
                onChange={(e) =>
                  onImageChange(
                    e,
                    setIconNavigationBarPreview,
                    setIconNavigationBar
                  )
                }
              />
            </div>

            {configErrors.iconNavigationBar && (
              <small className="text-danger">
                {configErrors.iconNavigationBar}
              </small>
            )}
          </Col>

          {(iconNavigationBarPreview || iconNavigationBar) && (
            <Col md={4}>
              <img
                src={iconNavigationBarPreview || iconNavigationBar}
                alt="icon"
                style={{ width: 50, cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    iconNavigationBarPreview || iconNavigationBar,
                    "_blank"
                  )
                }
              />
            </Col>
          )}
        </Row>

        <Row className="mt-3">
          <Col md={12}>
            <Label>Título da Barra de Navegação*</Label>
            <Input
              value={titleNavigationBar}
              onChange={(e) => setTitleNavigationBar(e.target.value)}
            />
            {configErrors.titleNavigationBar && (
              <small className="text-danger">
                {configErrors.titleNavigationBar}
              </small>
            )}
          </Col>
        </Row>

        <Row className="align-items-center mt-3">
          <Col md={6} className="pe-2">
            <SingleColorPicker
              className="PortalColorCard"
              label="Cor Primária*"
              defaultColor={primaryColor}
              setStateFunc={handleSetPrimaryColor}
              tip="Cor dos detalhes do portal (Botões, Mensagem de validação)."
            />
          </Col>

          <Col md={6} className="pe-2">
            <SingleColorPicker
              className="PortalColorText"
              label="Cor Secundária*"
              defaultColor={secondaryColor}
              setStateFunc={handleSetSecondaryColor}
              tip="Cor do BG e do Menu principal."
            />
          </Col>
        </Row>
      </>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.primaryColor === nextProps.primaryColor &&
      prevProps.secondaryColor === nextProps.secondaryColor &&
      prevProps.titleNavigationBar === nextProps.titleNavigationBar &&
      prevProps.imageLoginScreenPreview === nextProps.imageLoginScreenPreview &&
      prevProps.iconNavigationBarPreview === nextProps.iconNavigationBarPreview
    );
  }
);
